"use client"

import { Business, Contact, Household } from "@/schema"
import { Mention } from "@/schema/cross_reference"
import { useGlobalDialogStore } from "@/stores/use-global-dialog-store"

import CreateTaskDialog, { CreateTaskDialogProps } from "./create/dialog"

interface CreateTaskOptions {
  allowRelationshipChange?: boolean
  prefillData?: CreateTaskDialogProps["prefillData"]
  defaultHousehold?: Household
  defaultContact?: Contact
  defaultBusiness?: Business
  defaultMentions?: Mention[]
  defaultProjectId?: string
  defaultProjectMilestoneId?: string
  recommendable?: {
    type: string
    id: string
  }
  syncboxThreadId?: string
  onCreated?: () => void
}

export function useCreateTaskComponent({
  defaultHousehold,
  defaultContact,
  defaultBusiness,
  defaultMentions,
}: {
  defaultHousehold?: Household
  defaultContact?: Contact
  defaultBusiness?: Business
  defaultMentions?: Mention[]
} = {}) {
  const { openDialog, closeDialog } = useGlobalDialogStore()

  return {
    open: (options?: CreateTaskOptions) => {
      openDialog({
        variant: "custom",
        content: (
          <CreateTaskDialog
            allowRelationshipChange={options?.allowRelationshipChange}
            defaultHousehold={options?.defaultHousehold || defaultHousehold}
            defaultContact={options?.defaultContact || defaultContact}
            defaultBusiness={options?.defaultBusiness || defaultBusiness}
            defaultMentions={options?.defaultMentions || defaultMentions}
            defaultProjectId={options?.defaultProjectId}
            defaultProjectMilestoneId={options?.defaultProjectMilestoneId}
            recommendable={options?.recommendable}
            syncboxThreadId={options?.syncboxThreadId}
            prefillData={options?.prefillData}
            onCreated={options?.onCreated}
          />
        ),
      })
    },
    close: () => {
      closeDialog()
    },
  }
}
